import { BusinessObject } from './business-object.js'
import {
	jsonClass,
	jsonProperty,
	jsonArrayProperty,
	jsonMapProperty,
} from '@sumbricht/json-class-serializer'
import { assignCommonProperties } from '../util/data/assign-common-properties.js'

import { Parameter } from '../script/parameter.js'

@jsonClass('Label')
export class Label extends BusinessObject {
	@jsonMapProperty(String, String) translations: Map<string, string> = new Map()
	@jsonProperty(Boolean) canHaveInputs: boolean = false
	@jsonProperty(Boolean) canContainHtml: boolean = false
	@jsonArrayProperty(Parameter) inputs: Parameter[] = []

	constructor(init?: Partial<Label>) {
		super()
		assignCommonProperties(this, init)
	}

	getClassNames(): string[] {
		return ['$T']
	}
}
